import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import MessageType from '../../../../../enums/MessageType';
import CheckIcon from '../../../../../UI/SelectableContainer/CheckIcon';
import isUsingArtemisStyles from '../../../../selectors/isUsingArtemisStyles';
import ErrorIcon from '../../svg/Components/ErrorIcon';
import InfoIcon from '../../svg/Components/InfoIcon';

export function MessageIcon(props) {
  switch (props.type) {
    case MessageType.ERROR:
      return <ErrorIcon isArtemisIcon={props.isUsingArtemisStyles} />;
    case MessageType.SUCCESS:
      return <CheckIcon brand={false} isArtemisIcon={props.isUsingArtemisStyles} />;
    case MessageType.INFO:
      return <InfoIcon isArtemisIcon={props.isUsingArtemisStyles} />;
    default:
      return null;
  }
}

const mapStateToProps = state => ({
  isUsingArtemisStyles: isUsingArtemisStyles(state),
});

MessageIcon.propTypes = {
  type: PropTypes.oneOf(Object.values(MessageType)),
  isUsingArtemisStyles: PropTypes.bool,
};

export default connect(mapStateToProps)(MessageIcon);
